// extracted by mini-css-extract-plugin
export default {"wrapperFavoriteIcon":"Favorite_wrapperFavoriteIcon__EnTkB"};